export const NEW_BUTTON_ENTRY_SOURCE = 'NewButton';
export const KEYBOARD_SHORTCUT_ENTRY_SOURCE = 'KeyboardShortcut';
export const NEW_BUTTON_ANCHOR_NAME = 'NewEventButtonAnchor';
export const NEW_BUTTON_ANCHOR = '#' + NEW_BUTTON_ANCHOR_NAME;
export const NEW_BUTTON_RIBBON_ID = '2501'; // Keep in sync with RibbonId in /owa-ribbon-ids
export const NEW_BUTTON_RIBBON_ANCHOR = '[data-unique-id="Ribbon-' + NEW_BUTTON_RIBBON_ID + '"]';
